import React, { Fragment } from 'react';
import { Size, FontWeight } from '../../../styles/theme.mjs';
import LineSeparator from '../../Basic/LineSeparator/LineSeparator.mjs';
import { Variant } from '../../Basic/LineSeparator/LineSeparator.styles.mjs';
import StyledLink from '../../Basic/Link/Link.mjs';
import FlexContainer from '../../Containers/FlexContainer/FlexContainer.mjs';
import { StyledRelatedStoriesFlexContainer, StyledRelatedStoriesHeading, StyledRelatedStoriesText } from './RelatedStories.styles.mjs';
import { useTheme } from 'styled-components';

const RelatedStories = ({ title, stories, margin = [0, '1.25rem 0'] }) => {
    const theme = useTheme();
    return (React.createElement(StyledRelatedStoriesFlexContainer, { direction: "column", gap: "1rem", margin: margin },
        React.createElement(StyledRelatedStoriesHeading, { color: theme.colors.relatedStoriesHeading, tag: "h3" }, title),
        React.createElement(FlexContainer, { direction: "column", gap: "1rem" }, stories.map(({ heading, href, publishedAt }, index) => (React.createElement(Fragment, { key: href },
            index > 0 && React.createElement(LineSeparator, { variant: Variant.Strong, margin: "0" }),
            React.createElement(StyledLink, { href: href },
                React.createElement(FlexContainer, { direction: "column", gap: "0.5rem" },
                    React.createElement(StyledRelatedStoriesHeading, { tag: "h4" }, heading),
                    React.createElement(StyledRelatedStoriesText, { color: theme.colors.relatedStoriesTimestamp, tag: "p", fontWeight: FontWeight.Medium, size: Size.Micro }, publishedAt)))))))));
};

export { RelatedStories as default };
//# sourceMappingURL=RelatedStories.mjs.map
